import moment from "moment";
import { convertValue } from "../config/app-globals.enum";

export function titleCase(string: string) {
	if (string) {
		return string
			.split(" ")
			.map((x) => capitalizeFirstLetter(x))
			.join(" ");
	} else {
		return "";
	}
}

function capitalizeFirstLetter(string: string) {
	if (string) return string[0].toUpperCase() + string.slice(1).toLowerCase();
	return "";
}

export function getInitials(name: string) {
	try {
		let initial = "";
		if (name) {
			const nameArray = name.split(" ");
			if (nameArray && nameArray.length) {
				if (nameArray[0]) {
					initial += nameArray[0][0];
				}
				if (nameArray.length > 1) {
					if (nameArray[nameArray.length - 1]) {
						initial += nameArray[nameArray.length - 1][0];
					}
				}
			}
			// for (let i = 0; i < nameArray.length; i++) {
			//   if (nameArray[i]) {
			//     initial += nameArray[i][0];
			//   }
			// }
		}
		return initial;
	} catch (error) { }
	return "";
}

export function getInitialsUser(user: any) {
	try {
		if (user) {
			let initial = "";
			const nameArray = [];
			if (user.nameArray && user.nameArray.length) {
				let _nameArray = [];
				let __nameArray = user.nameArray[0].split(" ");
				_nameArray.push(__nameArray[0]);
				if (__nameArray.length > 1 && __nameArray[__nameArray.length - 1]) {
					_nameArray.push(__nameArray[__nameArray.length - 1]);
				}
				if (user.nameArray.length > 1 && user.nameArray[user.nameArray.length - 1]) {
					_nameArray.push(user.nameArray[user.nameArray.length - 1]);
				}
				_nameArray.forEach((item) => {
					nameArray.push(item);
				});
			} else {
				if (user.firstName) {
					nameArray.push(user.firstName);
				}
				if (user.lastName) {
					nameArray.push(user.lastName);
				} else if (user.middleName) {
					nameArray.push(user.middleName);
				}
			}
			for (let i = 0; i < nameArray.length; i++) {
				initial += nameArray[i][0];
			}
			return initial;
		}
	} catch (error) { }
	return "";
}

export const statusMessage = [
	"BrakingCampaign",
	"BrakingImpactMessages",
	"BrakingImprovementMessages",
	"BrakingInformativeMessages",
	"CorneringCampaign",
	"CorneringImpactMessages",
	"CorneringImprovementMessages",
	"CorneringInformativeMessages",
	"DriversPledgeBroken",
	"DriversPledgeAccepted",
	"Generic",
	"Inactive",
	"Introductory",
	"SpeedingFrequentCampaign",
	"SpeedingFrequentImpactMessages",
	"SpeedingFrequentImprovementMessages",
	"SpeedingFrequentInformativeMessages",
	"SpeedingHighCampaign",
	"SpeedingHighImpactMessages",
	"SpeedingHighImprovementMessages",
	"SpeedingHighInformativeMessages",
	"WaitingForDriversPledge",
	"Welcome",
	"Max",
];

export const eventCategories = {
	braking: ["Heavy Braking", "Over-use of Brakes"],
	cornering: ["Excess Speed", "Fast Approach", "Poor Technique"],
};

export const addDataToReport = (data: any) => {
	let _data = data.map((d) => {
		return {
			date: d.EntryDate,
			braking: d.EngagementStatus.BrakingPercentage * 100,
			cornering: d.EngagementStatus.CorneringPercentage * 100,
			speeding: d.EngagementStatus.SpeedingPercentage * 100,
			score: d.EngagementStatus.DriverScore,
		};
	});
	const maxScore = Math.max(..._data.map((o) => o.score));
	const minScore = Math.min(..._data.map((o) => o.score));
	return { minScore: minScore, maxScore: maxScore, averageData: [..._data] };
};


export const kMPToMPH = (kmp: any) => {
	if (kmp !== undefined && kmp !== null) {
		const val = kmp / convertValue.KMP_TO_MPH;
		return `${kmp.toFixed(4)} km/h (${val.toFixed(4)} mph)`;
	}
};

export const meterToMiles = (meterDistance: any, appendMiles: boolean = true) => {
	if (meterDistance !== undefined && meterDistance !== null) {
		const val = +(+meterDistance / convertValue.METER_TO_MILES).toFixed(2);
		if (appendMiles) {
			return `${val} Miles`;
		}
		return `${val}`;
	}
};

export const dateTimeConvert = (date: Date) => {
	return moment(date).format("dddd, DD, MMM, YYYY | h:mm:ss");
}

export const flat = (obj: any, out: any) => {
	Object.keys(obj).forEach(key => {
		if (typeof obj[key] == 'object' && obj[key] !== null) {
			out = flat(obj[key], out) //recursively call for nesteds
		} else {
			out[key] = obj[key] //direct assign for values
		}

	})
	return out;
};

export const getMileageClaimDateRange = (date1: Date, date2: Date) => {
	let dateRange = "";
	try {
		if (date1.getFullYear() === date2.getFullYear()) {
			dateRange = moment(date1).format('DD MMM - ');
		} else {
			dateRange = moment(date1).format('DD MMM, yyyy - ');
		}
		dateRange += moment(date2).format('DD MMM, yyyy');
	} catch (error) { }
	return dateRange;
}